/*jshint esversion: 6 */

import { domReady } from '../common/dom-ready';

(function(){

    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Set up the responsive main menu dialog
    //////////////////////////////////////////////////////////////////////////////////////////////////////////
    let maxDialogWidth = 992; // bootstrap5 lg size
    let dialogHeight = 0;
    let dialogSelector = '#main-menu-dialog';

    domReady(function(){
        console.log('ready window height: '+window.innerHeight);
        console.log('ready window width: '+window.innerWidth);
        // jquery ui dialog
        let dialogSettings = {
            autoOpen: false,
            width: Math.min(window.innerWidth, maxDialogWidth),
            height: window.innerHeight,
            draggable: false,
            resizable: false,
            modal: true,
            dialogClass: "main menu",
            position: {
                my: "center top",
                at: "center top",
                of: "body"
            },
            title: "",
            show: {
                effect: "blind",
                duration: 500
            },
            hide: {
                effect: "blind",
                duration: 500
            },
            open: function(){
                document.querySelector('.ui-widget-overlay').addEventListener('click', function() {
                    $(dialogSelector).dialog('close');
                })
                // button fix for jQuery UI close button icon X problem
                $(dialogSelector).closest(".ui-dialog")
                    .find(".ui-dialog-titlebar-close")
                    .empty()
                    .addClass("ui-button ui-corner-all ui-widget ui-button-icon-only")
                    .attr("title", "Close")
                    .append("<span class='ui-button-icon ui-icon ui-icon-closethick'></span>")
                    .append("<span class='ui-button-icon-space'> </span>Close");
            },
            closeOnEscape: true,
        };

        if(window.innerWidth > maxDialogWidth) {
            delete dialogSettings.height;
            dialogSettings.position = {
                my: "left top",
                at: "left bottom",
                of: $("button.main.menu")
            }
        }

        $(dialogSelector).dialog(dialogSettings);

        document.querySelectorAll('button.main.menu').forEach(function(button) {
            button.addEventListener('click', function() {
                $(dialogSelector).dialog("open");
            });
        });

        // Mobile devices change width depending on orientation and this will resize the width accordingly.
        // It is also helpful for testing e.g. in responsive chrome dev tools the dialog will stay full width.
        window.addEventListener('resize', function() {
            if(window.innerWidth <= maxDialogWidth) {
                $(dialogSelector).dialog('option', 'width', window.innerWidth);
            }
        });
    });
})();
